<template>
  <div class="bigBody" id="index">
    <nav id="bodyTop" class="d_flex">
      <div class="d_flex">
        <div class="logoDiv"><img src="../../../assets/img/logo.png" width="150" style="margin-left:10px"/></div>
        <abbr style="height:24px;border: 2px solid #54565B;margin: 0 10px;background:#54565B;"></abbr>
        <span class="colorGray f_w font18">{{topName}}</span>
      </div>
      <div class="bodyTop_Right p_r">
        <ul style="font-size: 0" class="p_r">
          <li class=" font14 c_p">
            <div class="notice">
              <img src="../../../assets/img/voice.png"/>
              <div class="box">
                <span class="animate font14 f_w colorGray">
                  <span :key="index" v-for="(item, index) in noticeList">{{item}}</span>
                </span>
              </div>
            </div>
          </li>
          <li class=" font14 c_p">
            <span style="position: relative;display: flex;align-items: center;height: 60px;" @click="changeShowNotice()">
              <img v-if="unReadCount>0" src="../../../assets/img/notice.png" class="notice-icon"/>
              <img v-else src="../../../assets/img/no-notice.png" class="notice-icon"/>
              <span v-if="unReadCount>0" class="notice-num">{{unReadCount}}</span>
            </span>
            <section v-if="showNoticeView" class="noticeView">
              <section v-if="reminderList&&reminderList.length>0" v-for="(item,index) in reminderList" :key="index" style="margin: 0">
                <section v-if="index>0" class="line_view"></section>
                <section @click="item.Status==0?readReminder(item.Id,index):''" :id="item.Id"><span :class="item.Status==0?'isNew':''"></span>{{item.Reminder}}</section>
              </section>
              <div v-if="reminderList&&reminderList.length>0" @click="showReminder">{{$t('common.DetailedInformation')}}>></div>
              <div v-if="!reminderList||reminderList.length==0" style="color: #5c5e63;text-decoration: none;">{{$t('common.NoNotification')}}</div>
            </section>
          </li>
          <li class=" font14 c_p">
            <span style="position: relative" class="user-name" @click="changeRole()"><img class="avatar padHide" src="../../../assets/img/user-avatar.png" />{{userInfo.ADName}}</span><span class="padHide">，{{$t('common.Welcome')}}</span>
            <section v-if="showSelectRole" class="roleSelect">
              <section v-for="(item,index) in userInfo.Roles" :key="index" class="roleSelectData" :class="selectedRole==item.Code?'selected':''" @click="selectRoleFun(item.Role,item.Code)">{{item.RoleDisplay}}</section>
            </section>
          </li>
          <!-- 隐藏 English 语言切换按钮
          <li class=" font14 c_p">
            <span @click="changeLangEvent()" v-if="lang=='zh-CN'" class="lang-change">English</span>
            <span @click="changeLangEvent()" v-else class="lang-change">中文版</span>
          </li>
          -->
          <li class=" font14 c_p">
            <span @click="allExit()"><img class="icon" src="../../../assets/img/logout.png" /></span>
          </li>
        </ul>
      </div>
    </nav>
    <div id="managLeft" style="position: fixed;top: 60px;z-index: 10;">
      <myMenu :menuObj="menuList" :activeName.sync="activeMenuName"></myMenu>
    </div>
    <div id="managRight" style="position: relative; left: 60px; top: 60px;width: calc(100% - 80px);padding: 0 10px;">
      <transition name="fadeLeft">
        <router-view v-if="isRouterAlive"></router-view>
      </transition>
      <dialogArea :show="showReminderDialog" :width="'80%'" @cancel="reminderCancel" :title="$t('common.Notification')">
        <div slot="content">
          <table class="allTable" cellspacing="0">
            <thead>
              <tr>
                <th></th>
                <th>{{$t('common.Notification')}}</th>
                <th>{{$t('common.Time')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr class="c_p" v-for="(item,index) in allReminderList" :key="index" @click="item.Status==0?readReminder(item.Id, index,true):''">
                <td style="text-align: right;"><span v-if="item.Status==0" style="display: inline-block;width: 6px;height: 6px;border-radius: 5px;margin-right: 5px;background: #B62A40;"></span></td>
                <td>{{item.Reminder}}</td>
                <td>{{item.Created_date}}</td>
              </tr>
            </tbody>
          </table>
          <page :totalPage='pageData.totalPages' :page='pageData.pageIndex' @on-getList="pageChange"></page>
        </div>
        <div slot="foter"></div>
      </dialogArea>
    </div>
    <div v-if="this.showSelectRole || this.showNoticeView" class="hide_bg" @click="hideAlert"></div>
  </div>
</template>
<script>
import menu from '../../pages/left-menu/menu'
export default {
  name: 'index',
  components: {
    'myMenu': menu
  },
  data () {
    return {
      topName: '',
      userInfo: {},
      noticeList: [this.$t('common.NoAnnouncement')],
      menuList: [],
      activeMenuName: '',
      reminderList: [],
      allReminderList: [],
      unReadCount: 0,
      lang: window.localStorage.getItem('language'),
      selectedRole: false,
      showSelectRole: false,
      showNoticeView: false,
      showUser: false,
      showReminderDialog: false,
      isRouterAlive: false,
      pageData: {
        pageIndex: 1,
        pageSize: 10,
        totalPages: 0
      }
    }
  },
  destroyed () {
  },
  created () {
    this.getUserInfo()
    this.getNoticeList()
    this.getReminderList()
  },
  methods: {
    getUserInfo () {
      this.userInfo = false
      this.$axiox.get('/api/v1/admin/user/userinfo').then(msg => {
        if (msg.data) {
          this.userInfo = msg.data
          if (msg.data.Roles && msg.data.Roles.length > 0) {
            let currRole = localStorage.getItem('currentRole')
            if (currRole) {
              for (let item of msg.data.Roles) {
                if (item.Code === currRole) {
                  this.selectedRole = currRole
                  let data = {code: currRole}
                  this.$axiox.post('/api/v1/admin/user/changeRole', data).then(msg => {
                    localStorage.coeToken = msg.data.token
                    this.createMenuList(item.Role)
                  })
                  return
                }
              }
            }
            this.selectedRole = msg.data.Roles[0].Code
            localStorage.setItem('currentRole', this.selectedRole)
            this.createMenuList(msg.data.Roles[0].Role)
          } else {
            this.isRouterAlive = true
            this.$router.replace({
              name: 'noPermission'
            })
          }
        } else {
          this.isRouterAlive = true
          this.$router.replace({
            name: 'noPermission'
          })
        }
      })
    },
    getNoticeList () {
      this.$axiox.get('/api/v1/admin/notice').then(msg => {
        if (msg.data && msg.data.length > 0) {
          this.noticeList = msg.data
        }
      })
    },
    getReminderList () {
      let data = {
        pageIndex: 1,
        pageSize: 5
      }
      let url = this.$commonJs.returnQuery('/api/v1/admin/reminder/list', data)
      this.$axiox.get(url).then(msg => {
        if (msg.data) {
          this.unReadCount = msg.data.unreadcnt
          if (msg.data.items && msg.data.items.length > 0) {
            this.reminderList = msg.data.items
          }
        }
      })
    },
    getAllReminder (pageIndex) {
      this.pageData.pageIndex = pageIndex || 1
      let data = JSON.parse(JSON.stringify(this.pageData))
      let url = this.$commonJs.returnQuery('/api/v1/admin/reminder/list', data)
      this.$axiox.get(url).then(msg => {
        if (msg.data) {
          this.pageData.totalPages = msg.data.pages || 0
          if (msg.data.items && msg.data.items.length > 0) {
            this.allReminderList = msg.data.items
          }
        }
      })
    },
    readReminder (rId, index, isDialog) {
      this.$axiox.put('/api/v1/admin/reminder/' + rId).then(msg => {
        if (isDialog) {
          this.allReminderList[index].Status = 1
          this.unReadCount = this.unReadCount - 1
          if (this.pageData.pageIndex === 1 && index < this.reminderList.length) {
            this.reminderList[index].Status = 1
          }
        } else {
          this.reminderList[index].Status = 1
          this.unReadCount = this.unReadCount - 1
        }
      })
    },
    pageChange (pageIndex) {
      this.getAllReminder(pageIndex)
    },
    selectRoleFun (id, code) {
      if (localStorage.getItem('currentRole') === code) {
        this.showSelectRole = false
        return false
      }
      let data = {code: code}
      this.$axiox.post('/api/v1/admin/user/changeRole', data).then(msg => {
        localStorage.coeToken = msg.data.token
        this.selectedRole = code
        localStorage.setItem('currentRole', this.selectedRole)
        this.createMenuList(id, true)
        this.showSelectRole = false
      })
    },
    changeRole () {
      if (this.showSelectRole) {
        this.showSelectRole = false
      } else {
        this.showNoticeView = false
        this.showSelectRole = true
      }
    },
    changeShowNotice () {
      if (this.showNoticeView) {
        this.showNoticeView = false
      } else {
        this.showSelectRole = false
        this.showNoticeView = true
      }
    },
    createMenuList (selectedRole, isChangeRole) {
      this.menuList = []
      if (selectedRole === 'ASM') {
        this.menuList = [{
          active: 'ASM',
          iconName: 'icon iconfont icon-gouwuche',
          name: 'ASM',
          showMenu: true
        }]
      } else if (selectedRole === 'RSD') {
        this.menuList = [{
          active: 'RSD',
          iconName: 'icon iconfont icon-gouwuche',
          name: 'RSD',
          showMenu: true
        }]
      } else if (selectedRole === 'NSD') {
        this.menuList = [
          // {
          //   active: 'NSD',
          //   iconName: 'icon iconfont icon-gouwuche',
          //   name: 'NSD',
          //   showMenu: true
          // },
          {
            active: 'mkt',
            iconName: 'icon iconfont icon-gouwuche',
            name: 'mkt',
            showMenu: true
          }
        ]
      } else {
        this.userInfo.Roles.forEach(val => {
          if (val.Role === selectedRole && val.Modules && val.Modules.length > 0) {
            let i = 0
            val.Modules.forEach(m => {
              if (m.ModuleCode === 'Report') {
                this.menuList.push({
                  active: 'Report',
                  iconName: 'icon iconfont icon-zhuzhuangtu',
                  name: 'Report',
                  showMenu: true
                })
              } else if (m.ModuleCode === 'UserManage') {
                this.menuList.push({
                  active: 'UserManagement',
                  iconName: 'icon iconfont icon-yonghuguanli',
                  name: this.$t('common.UserManagement'),
                  showMenu: true
                })
              } else if (m.ModuleCode === 'RoleManage') {
                this.menuList.push({
                  active: 'RoleSetUp',
                  iconName: 'icon iconfont icon-jiaosequanxian',
                  name: this.$t('common.RoleManagement'),
                  showMenu: true
                })
              } else if (m.ModuleCode === 'MktCategoryManage') {
                this.menuList.push({
                  active: 'bazaar',
                  iconName: 'icon iconfont icon-leibie',
                  name: this.$t('common.MarketingCategoryManagement'),
                  showMenu: true
                })
              } else if (m.ModuleCode === 'NoticeManage') {
                this.menuList.push({
                  active: 'notice',
                  iconName: 'icon iconfont icon-gonggao',
                  name: this.$t('common.AnnouncemenetManagement'),
                  showMenu: true
                })
              } else if (m.ModuleCode === 'StartTimeManage') {
                this.menuList.push({
                  active: 'startData',
                  iconName: 'icon iconfont icon-kaishiriqi',
                  name: this.$t('common.StartDateManagement'),
                  showMenu: true
                })
              } else if (m.ModuleCode === 'ReadOnly') {
                this.menuList.push({
                  active: 'SalesReadOnly',
                  iconName: 'icon iconfont icon-gouwuche',
                  name: this.$t('common.SalesReadOnly'),
                  showMenu: true
                })
              } else if (m.ModuleCode === 'LEDataManagement') {
                this.menuList.push({
                  active: 'LEManagement',
                  iconName: 'icon iconfont icon-execute-stop',
                  name: this.$t('common.LEManagement'),
                  showMenu: true
                })
              } else if (m.ModuleCode === 'Admin') {
              } else {
                if (i === 0) {
                  this.menuList.push({
                    active: 'mkt',
                    iconName: 'icon iconfont icon-gouwuche',
                    name: 'Forecast',
                    showMenu: true
                  })
                  i++
                }
              }
            })
          }
        })
      }
      if (this.menuList && this.menuList.length > 0) {
        for (let menu of this.menuList) {
          if (menu.active === localStorage.getItem('currMenu')) {
            this.activeMenuName = localStorage.getItem('currMenu')
            if (isChangeRole) {
              this.isRouterAlive = false
              this.$nextTick(() => {
                this.isRouterAlive = true
                this.$router.replace({
                  name: menu.active
                })
              })
            } else {
              this.$nextTick(() => {
                this.isRouterAlive = true
                this.$router.replace({
                  name: menu.active
                })
              })
            }
            return
          }
        }
        this.activeMenuName = this.menuList[0].active
        localStorage.setItem('currMenu', this.activeMenuName)
        this.$nextTick(() => {
          this.isRouterAlive = true
          this.$router.replace({
            name: this.menuList[0].active
          })
        })
      }
    },
    showReminder () {
      this.getAllReminder()
      this.showReminderDialog = true
      this.showNoticeView = false
    },
    reminderCancel () {
      this.showReminderDialog = false
    },
    hideAlert () {
      this.showSelectRole = false
      this.showNoticeView = false
    },
    changeLangEvent () {
      window.location.reload()
      // this.$router.go(0)
      if (this.lang === 'zh-CN') {
        this.lang = 'en-US'
        window.localStorage.setItem('language', this.lang)
        this.$i18n.locale = this.lang
      } else {
        this.lang = 'zh-CN'
        window.localStorage.setItem('language', this.lang)
        this.$i18n.locale = this.lang
      }
    },
    allExit () {
      let data = {data: {}}
      data.data.token = localStorage.getItem('coeToken')
      this.$axiox.delete('/api/login/logout', data)
      setTimeout(() => {
        localStorage.removeItem('coeToken')
        localStorage.removeItem('currMenu')
        // localStorage.removeItem('currentRole')
        this.$router.replace({
          name: 'logout'
        })
      }, 50)
    }
  }
}
</script>

<style scoped>
  .lang-change{
    background-color: #B62A40;
    color: #ffffff;
    padding: 6px;
    font-size: 14px;
    border-radius: 3px;
  }
  .icon{
    width: 24px;
    height: 24px;
  }
  .avatar{
    width: 38px;
    height: 38px;
    border-radius: 19px;
  }
  .notice-icon{
    height: 34px;
  }
  .notice-num{
    font-size: 12px;
    transform: scale(0.7);
    display: inline-block;
    color: rgb(199, 51, 67);
    text-align: center;
    width: 15px;
    font-weight: bold;
    position: absolute;
    right: 5px;
    bottom: 1px;
  }
  .user-name{
    text-decoration: underline;
    color: #B62A40;
  }
  .notice {
    border: 1px solid #C73343;
    line-height: 38px;
    margin: 10px 0;
    padding: 0 10px;
    width: 300px;
    border-radius: 4px;
    display: flex;
  }
  .notice img{
    width: 20px;
    align-self: center;
    margin-right: 10px;
  }
  .box {
    /*margin: 0 auto;*/
    overflow: hidden;
    /*width: 330px;*/
    flex: 1;
  }
  .animate {
    display: inline-block;
    white-space: nowrap;
    animation: 10s wordsLoop linear infinite normal;
  }
  .animate span{
    display: inline-block;
    white-space: nowrap;
    margin-right: 50px;
  }
  @keyframes wordsLoop {
    0% {
      transform: translateX(200px);
      -webkit-transform: translateX(200px);
    }
    100% {
      transform: translateX(-100%);
      -webkit-transform: translateX(-100%);
    }
  }
  @-webkit-keyframes wordsLoop {
    0% {
      transform: translateX(200px);
      -webkit-transform: translateX(200px);
    }
    100% {
      transform: translateX(-100%);
      -webkit-transform: translateX(-100%);
    }
  }
  .noticeView{
    position: absolute;
    background-color: white;
    border-radius: 4px;
    /*margin-top: -10px;*/
    box-shadow: 0px 0px 5px 0px #ccc;
    width: 200px;
    font-size: 12px;
    overflow: hidden;
  }
  .noticeView div{
    background: #F5F5F5;
    text-align: center;
    line-height: 36px;
    color: #B62A40;
    text-decoration: underline;
  }
  .noticeView section{
    margin: 0 10px 0 5px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    line-height: 36px;
  }
  .noticeView section.line_view{
    margin: 0 15px;
    height: 1px;
    background: #ECECEC;
  }
  .noticeView section span{
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 5px;
    margin-right: 5px;
  }
  .noticeView section span.isNew{
    background: #B62A40;
  }
  .roleSelect{
    position: absolute;
    max-width: 220px;
    min-width: 150px;
    max-height: 306px;
    overflow-y: scroll;
    background-color: white;
    border-radius: 4px;
    /*margin-top: -10px;*/
    box-shadow: 0px 0px 5px 0px #ccc;
  }
  .roleSelectData{
    padding: 6px 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    /*position: relative;*/
    font-size: 12px;
    line-height: 20px;
  }
  .roleSelectData:hover {
    background-color: #efefef;
  }
  .selected {
    color: #C73343;
  }
  .allTable tbody tr:nth-of-type(odd) {
    background-color: #f9f9f9;
  }
  /*.allTable tbody tr:hover{*/
  /*  background-color: #FDF1F4;*/
  /*}*/
  .hide_bg{
    position: fixed;
    width: 100%;
    height: 100%;
    background: #1E1E1E;
    opacity: 0.2;
    top: 0;
    left: 0;
    z-index: 15;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/myIndex/index.vue